module.exports = __webpack_public_path__ + "static/media/17.54afc2e1.png";